module.exports = __webpack_public_path__ + "static/media/omkring.0df82338.mp3";